import React from "react";

const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
export const ThemeContext = React.createContext(defaultDark ? 'dark' : 'light');